import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface LockViewProps {
    setLocked: boolean;
}

export const LockView = ({ setLocked }: LockViewProps) => {
    const { t } = useTranslation();

    const { isMainCameraLocked, handleLockCameraControls } = usePlacementStore(
        useShallow((state) => ({
            isMainCameraLocked: state.isMainCameraLocked,
            handleLockCameraControls: state.handleLockCameraControls
        }))
    );

    return (
        <Menu.Item
            disabled={setLocked ? isMainCameraLocked : !isMainCameraLocked}
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon={setLocked ? 'lock' : 'lock_open'}
                />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right text-[13px]">
                    {setLocked ? ShortcutAction.LockView : ShortcutAction.UnlockView}
                </Text>
            }
            onClick={() => handleLockCameraControls(setLocked)}
        >
            {setLocked ? t('buttonLockView') : t('buttonUnlockView')}
        </Menu.Item>
    );
};
